import { environment } from 'src/environments/environment';

/**
 * Logger de la aplicación.
 *
 * Portado del repo de clientes via mitter-driver-app (`src/app/core/log.ts`), por las mismas razones:
 * el código llama a `console.log()` en decenas de sitios y varios vuelcan objetos
 * completos —el pedido con su dirección y su teléfono, el usuario de Firebase con su
 * correo y su uid—. En un build de producción eso queda en la consola del navegador (y,
 * cuando la app tenía APK, al alcance de un `adb logcat`).
 *
 * - `log()` es para mensajes de desarrollo: **no imprime nada en producción**.
 * - `warn()` y `error()` imprimen siempre: son señales operativas, no ruido.
 *
 * Son funciones y no un servicio inyectable para que migrar cada sitio de llamada sea
 * cambiar el nombre y sumar un import, sin tocar un solo constructor.
 *
 * Se portó del cliente junto con `PushService`, que se borró en la fase 0b: la app ya no
 * tiene push de Cordova.
 */

/** Mensaje de desarrollo. En producción no imprime. */
export function log(...args: unknown[]): void {
  if (!environment.production) {
    console.log(...args);
  }
}

/** Aviso que hay que ver también en producción. */
export function warn(...args: unknown[]): void {
  console.warn(...args);
}

/** Error que hay que ver también en producción. */
export function error(...args: unknown[]): void {
  console.error(...args);
}
